import Swiper from "swiper";
import { Pagination, Thumbs } from "swiper/modules";

export const sliderGallery = (function () {
  const init = function () {
    const swiper = new Swiper(".gallery-nav", {
      slidesPerView: 3,
      spaceBetween: 10,
      breakpoints: {
        1366: {
          spaceBetween: 16
        }
      }
    });
    const swiper2 = new Swiper(".gallery-slider", {
      modules: [Pagination, Thumbs],
      slidesPerView: "auto",
      spaceBetween: 60,
      pagination: {
        el: ".swiper-pagination",
        clickable: "true",
        type: "bullets",
        bulletElement: "button",
      },
      thumbs: {
        swiper: swiper
      }
    });
  };

  return {
    init,
  };
})();
